// extracted by mini-css-extract-plugin
export default {"toggleContainer":"styles_toggleContainer__98ElK","toggleButton":"styles_toggleButton__WzSbm","icon":"styles_icon__cQLob"};